import React from 'react';

const Loading = ({ visible }) => {
  if (!visible) return null;

  return (
    <div className="flex items-center justify-center py-8">
      <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
    </div>
  );
};

export default Loading;
